import type Vue from 'vue';
import { init as initWebsocket } from '@/services/websocket';
import { init as initBugsnag } from '@/services/bugsnag';
import { init as initGoogleFilePicker } from '@/services/google-file-picker';

interface ServicesOptions {
    bugsnag?: Parameters<typeof initBugsnag>[1];
    googleFilePicker?: Parameters<typeof initGoogleFilePicker>[0];
    websocket: Parameters<typeof initWebsocket>[0];
}

export function useServices(app: typeof Vue, options: ServicesOptions) {
    if (options.bugsnag) {
        initBugsnag(app, options.bugsnag);
    }

    initGoogleFilePicker(options.googleFilePicker);
    initWebsocket(options.websocket);
}
